<script>
  import HeroConfirmation from "$lib/components/EventConfirmation/HeroConfirmation.svelte";
  import { transformEventToDisplayFormat, buildIcsUrl } from "$lib/utilities/eventFormatters.js";

  export let orderType;
  export let tickets = [];
  export let confirmationNumber = "unknown-confirmation-number";

  // This is just a hopefully temporary fix to allow for certain events to use certain email addresses.
  const watchPartyId = "5a24599e-35d5-67cb-ad5e-e37ee200541d";
  const grandopeningIds = [
    "d26fe135-fba8-aef3-0be5-cf4135a39702",
    "019dda71-c13e-e53c-59ab-6afa2cb9ae9d",
    "019dda78-ff55-1e81-2f30-8cb6753b2f76"
  ];

  let supportEmail = "";

  const eventTemplateIds = tickets.map((ticket) => ticket.eventTemplateId);

  if (eventTemplateIds.includes(watchPartyId)) {
    supportEmail = "watchparty@email.obama.org";
  } else if (eventTemplateIds.some((template) => grandopeningIds.includes(template))) {
    supportEmail = "grandopening@events.obama.org";
  } else {
    supportEmail = "tickets@obama.org";
  }

  const hasTickets = tickets && tickets.length > 0;
  const isOnlyMuseumTickets = tickets && tickets.every((ticket) => ticket.type === "Museum");
  const isOnlyEventTickets = tickets && tickets.every((ticket) => ticket.type === "Event");

  // only display add To Calendar if all tickets are for the same Event/Admission (Donations exluded)
  const ticketsWithDonationsExcluded = tickets.filter((ticket) => ticket.type != "Donation");
  const allShareSameEvent =
    ticketsWithDonationsExcluded.length &&
    ticketsWithDonationsExcluded.every(
      (ticket) =>
        ticket.eventTemplateId &&
        ticket.eventTemplateId === ticketsWithDonationsExcluded[0].eventTemplateId
    );

  // Where the "Add to calendar" CTA appears depends on the ticket types:
  //  • events → "When" card
  //  • Admission tickets → "Ticket Details" card
  const showCalendarInWhenCard = allShareSameEvent && isOnlyEventTickets;
  const showCalendarInTicketDetails = allShareSameEvent && !isOnlyEventTickets;

  const buildAddToCalendarCta = (eventFields) => {
    return {
      text: "Add to calendar",
      type: "textLink",
      url: buildIcsUrl(eventFields),
      id: "add-to-calendar",
      preventOpenInNewTab: true
    };
  };

  // Hero content
  const heroTitle = {
    purchase: "Purchase Complete",
    registration: "Reservation Complete",
    request: "You're All Set"
  };
  let heroSubtitle = hasTickets
    ? "Tickets are headed to your email."
    : "Confirmation is headed to your email.";

  if (orderType == "request") {
    heroSubtitle = "Watch your inbox for more details.";
  }
  // Action bar data
  let actionBar = {
    text: `Confirmation number:\n${confirmationNumber}\n\nQuestions? Reach out to us at\n[${supportEmail}](mailto:${supportEmail}).`,
    actions: []
  };

  if (hasTickets) {
    if (showCalendarInWhenCard) {
      const event = tickets[0];
      const eventDetails = event?.details?.fields;
      // Removing View Event CTA for UAT
      // add back later

      // actionBar.actions.push({
      //   title: eventDetails?.title ?? event.name ?? "",
      //   description: eventDetails?.summary ?? event.summary ?? "",
      //   cta: eventDetails.slug
      //     ? {
      //         text: "View Event",
      //         type: "textLink",
      //         url: convertToEventDetailUrl(eventDetails.slug),
      //         id: "1"
      //       }
      //     : null
      // });

      if (eventDetails) {
        const details = transformEventToDisplayFormat({ event: eventDetails });

        if (details) {
          let description = "";

          if (details.eventDate) {
            description += details.eventDate;
          }
          if (details.eventTime) {
            description += description ? ` • ${details.eventTime}` : details.eventTime;
          }
          if (details.eventLocation) {
            description += description ? `\n${details.eventLocation}` : details.eventLocation;
          }

          actionBar.actions.push({
            title: "When",
            description,
            cta: buildAddToCalendarCta(eventDetails)
          });
        }
      }
    }

    let ticketsDescription = tickets
      .map((ticket) => {
        if (tickets.length > 1 && !isOnlyMuseumTickets && ticket.type === "Event") {
          return `${ticket.quantity ?? ""} ${ticket.details.fields.title ?? ""} ${
            ticket.name ?? ""
          }`;
        }
        return `${ticket.quantity ?? ""} ${ticket.name} (${ticket.ticketType})`;
      })
      .join("\n");

    actionBar.actions.push({
      title: "Ticket Details",
      description: ticketsDescription,
      cta:
        showCalendarInTicketDetails &&
        tickets[0].details?.fields?.start &&
        tickets[0].details?.fields?.end
          ? buildAddToCalendarCta(tickets[0].details.fields)
          : null
    });
  }

  actionBar.actions.push({
    title: "Membership",
    description:
      "Become a Founding Member with a recurring gift—monthly or annually—and help fuel emerging leaders, community-driven solutions, and lasting change.",
    cta: {
      text: "Become a member",
      type: "textLink",
      url: "?form=W26XXWFMEM0SO",
      id: "become-a-member"
    }
  });
</script>

<HeroConfirmation
  title={orderType ? heroTitle[orderType] : ""}
  subtitle={heroSubtitle}
  {actionBar}
/>
